import { Button } from "@components/index";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";
import type React from "react";

type Props = {
  close: () => void;
};

const HeaderButtonConfiguration: React.FC<Props> = ({ close }) => {
  const navigate = useSafeNavigate();

  const goTo = () => void navigate("/danger-zones");

  return (
    <Button
      blockedWidth
      size="lg"
      content="start"
      buttonStyle="tertiary"
      icon="settings"
      label="Configuração de Risco | Meta"
      onClick={() => {
        close();
        goTo();
      }}
    />
  );
};

export default HeaderButtonConfiguration;
